module.exports = __webpack_public_path__ + "static/img/c3.b4598e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c3.jpg
// module id = 5vFt
// module chunks = 1